import React from "react";
import { Button, Card, Stack, Text, Icon } from "@chaser/components";
import { useHistory } from "react-router-dom";
import PageContainer from "../../../components/PageContainer";
import LoadingMessage from "../../../components/LoadingMessage";
import useCashFlowForecastTrial from "../../../hooks/useCashFlowForecastTrial";
import screenshotImg from "../../../assets/cashflow-forecast/cashflow_intelligence_table_page.png";
import styles from "./CashFlowForecastTease.module.scss";

const CashFlowForecastTease = ({ isTrialExpired, isChaserTrial }) => {
  const { startTrial, loading } = useCashFlowForecastTrial();
  const router = useHistory();
  const handleActivateAddon = () => {
    router.push("/settings/subscription/addons");
  };

  return (
    <PageContainer>
      <div className={styles.wrapper}>
        <div className={styles.background}>
          <img
            className={styles.screenshot}
            src={screenshotImg}
            alt=""
            aria-hidden="true"
          />
        </div>
        <div className={styles.overlay} />
        <div className={styles.ctaContainer}>
          <Card p={0} className={styles.ctaCard}>
            <Stack alignItems="center" gap="small" className={styles.cardBody}>
              <div className={styles.iconCircle}>
                <Icon name="forecast-banner" color="#000000" />
              </div>
              {isTrialExpired ? (
                <>
                  <Text
                    as="h2"
                    fontSize="large"
                    fontWeight="bold"
                    className={styles.heading}
                  >
                    Your trial has expired
                  </Text>
                  <Text as="p">
                    You'll be redirected to the add-ons page to complete this
                    purchase.
                  </Text>
                </>
              ) : (
                <>
                  <Text
                    as="h2"
                    fontSize="large"
                    fontWeight="bold"
                    className={styles.heading}
                  >
                    Forecast your cash flow
                  </Text>
                  <Text as="p">
                    Get a <strong>3-day free trial.</strong> See exactly where
                    your cash position is heading and plan ahead with
                    confidence. No credit card or subscriber approval is needed
                    to start.
                  </Text>
                </>
              )}
            </Stack>
            <hr className={styles.divider} />
            <div className={styles.cardFooter}>
              {isTrialExpired ? (
                <Button
                  onClick={handleActivateAddon}
                  data-trackingid="cashflow-forecast-activate-addon"
                >
                  Activate add-on
                </Button>
              ) : loading ? (
                <LoadingMessage />
              ) : (
                <Button
                  onClick={startTrial}
                  data-trackingid="cashflow-forecast-trial-start"
                >
                  Start free trial
                </Button>
              )}
            </div>
          </Card>
        </div>
      </div>
    </PageContainer>
  );
};

export default CashFlowForecastTease;
